import {Col, FormGroup, Input, Label} from "reactstrap";
import React from "react";
import {withErrorBoundary} from "../../../boundaries/withErrorBoundary";
import GeneralErrorBoundary from "../../../boundaries/GeneralErrorBoundary";

const BrocadeInputs = ({
                           device,
                           array_name,
                           handleInputChange,
                           lgColSize,
                       }) => {
    if (['BROCADE_DEVICE', 'TEST_BROCADE_DEVICE'].includes(device?.trim().toUpperCase())) {
        return (
            <>
                <Col lg={lgColSize} sm={6}>
                    <FormGroup>
                        <Label htmlFor="array_name">Virtual Fabric (Optional)</Label>
                        <Input
                            required={false}
                            type="text"
                            name="array_name"
                            value={array_name}
                            onChange={handleInputChange}
                        />
                    </FormGroup>
                </Col>
            </>
        );
    } else {
        return null;
    }
};

export default withErrorBoundary(BrocadeInputs, GeneralErrorBoundary);
